import type { AwardLevelKey } from '@wlb/shared/utils/progress';
import achiever from '../../assets/images/awards/achiever.png';
import champion from '../../assets/images/awards/champion.png';
import comment from '../../assets/images/awards/comment.png';
import elite from '../../assets/images/awards/elite.png';
import energizer from '../../assets/images/awards/energizer_light.png';
import legend from '../../assets/images/awards/legend.png';
import post from '../../assets/images/awards/post.png';
import postLike from '../../assets/images/awards/post_like.png';
import risingStar from '../../assets/images/awards/rising_star.png';
import sharePost from '../../assets/images/awards/share_post.png';
import starter from '../../assets/images/awards/starter.png';
import supporter from '../../assets/images/awards/supporter.png';
import type { AwardRuleIconKey } from './awardRuleIcon';

export const AWARD_LEVEL_ARTWORK: Record<AwardLevelKey, string> = {
  starter,
  risingStar,
  supporter,
  energizer,
  achiever,
  champion,
  legend,
  elite,
};

export const AWARD_RULE_ARTWORK: Record<AwardRuleIconKey, string> = {
  post,
  comment,
  like: postLike,
  share: sharePost,
  /* No delete artwork ships in either asset set: mobile's `APP_IMAGES.PostDelete`
     resolves to the same rising_star.png, so reusing it keeps the two platforms
     identical until design supplies a dedicated asset. */
  delete: risingStar,
};
